import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { CommonPatternsService } from 'src/app/common-patterns.service';
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  @Output() confirmed = new EventEmitter<{ confirmed: boolean, selectedCheckboxes?: { label: string, checked: boolean, id: number }[], selectedCcCheckboxes?: { label: string, checked: boolean }[] }>();
  @Input() message: string = '';
  @Input() isCorporate: boolean = false;
  @Input() languageData;
  @Input() isAdvisor: boolean = false;
  @Input() checkboxes: { label: string, checked: boolean, id: number }[] = [];
  @Input() ccCheckboxes: { label: string, checked: boolean }[] = [];
  email: string
  editIndex: number;
  public lang: any = {};
  selectedLanguage: string;
  // emailPattern = '^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$';
  ccForm: FormGroup = new FormGroup({
    email: new FormControl(''),
  });
  constructor(private logger: LoggerService,
    private formBuilder: FormBuilder,
    private commonPatternsService: CommonPatternsService,
  ) { }

  validateDuplicate = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.ccCheckboxes?.some(cc => cc.label === control.value)) {
      return { duplicateMail: true };
    }
    return null;
  };

  ngOnInit(): void {
    this.lang = {};
    this.languageData =   this.languageData ?? [];
    this.selectedLanguage = sessionStorage.getItem("language")
    for (let token of this.languageData) {
      this.lang[token.key] = token[this.selectedLanguage];
    }


    console.log(this.checkboxes)

  console.log(this.lang)
    this.email = ''
    this.editIndex = -1;
    this.ccForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.compose([Validators.pattern(this.commonPatternsService.emailPattern), this.validateDuplicate]),

        ],
      ],
    })


  }

  checkCheckbox() {
    if (this.checkboxes?.some(cb => cb.checked)) {
      this.emailError = ''
    }
  }




  shouldDisableConfirmButton(): boolean {
    if ((this.isCorporate || this.isAdvisor) && this.checkboxes?.length > 0) {

      if (this.checkboxes?.some(cb => cb.checked)) {
        this.emailError = ''
        return false
      }
      this.emailError = "Please select atleast one group contact to send mail"
      return true
    }
    return false;
  }

  confirm() {
    const disabled = this.shouldDisableConfirmButton()
    if (disabled) return
    this.confirmed.emit({
      confirmed: true,
      ...(this.isCorporate && { selectedCheckboxes: this.checkboxes.filter(cb => cb.checked) }),
      ...(this.isAdvisor && { selectedCheckboxes: this.checkboxes.filter(cb => cb.checked), selectedCcCheckboxes: this.ccCheckboxes.filter(cb => cb.checked) })
    });
  }

  cancel() {
    this.confirmed.emit({ confirmed: false });
  }

  onchange(event) {
    this.email = event.target?.value

  }

  public emailError: any;

  get cc() {
    return this.ccForm.controls;
  }

  addEmail() {
    console.log(this.ccForm.controls)
    if (this.ccForm.invalid) {
      this.ccForm.markAllAsTouched()
      return
    }
    if (this.email && !this.ccCheckboxes.some(cc => cc.label === this.email)) {
      console.log(this.editIndex)
      if (this.editIndex >= 0) {
        this.ccCheckboxes[this.editIndex].label = this.email;
      }
      else {

        this.ccCheckboxes.push({ label: this.email, checked: false });
      }
      this.email = '';
      this.editIndex = -1;
    }

  }
  deleteEmail(email: string) {
    this.ccCheckboxes = this.ccCheckboxes.filter(cc => cc.label !== email);
  }
  editEmail(newEmail: string, index: number,) {
    this.email = newEmail;
    this.editIndex = index

    console.log({ index })
    console.log(this.editIndex)
    console.log(this.email, newEmail,)
  }
}
